<template>
  <dd-number-input
      v-bind="$attrs"
      :data-dusk="dataDusk"
      :parser="valueToFormat => valueToFormat.replace(/\€\s?|(,*)/g, '')"
      :formatter="valueToFormat => `€ ${valueToFormat}`"
      :value="value"
      @input="(newValue) => $emit('input', newValue)">
  </dd-number-input>
</template>

<script>
export default {
  name: "AmountInput.vue",
  emits: ['input'],
  props: {
    dataDusk: String,
    value: [String, Number],
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
